"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = exports.subprojectMeta = exports.defaultQueryParams = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var ColumnFilter_1 = require("components/ColumnFilter");
var react_router_dom_1 = require("react-router-dom");
var moment = require("moment");
var sok_ui_1 = require("@caddigital/sok-ui");
var subprojectActions = require("@caddigital/sok-reducers/lib/actions/subproject/list");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var list_1 = require("utils/list");
var search_1 = require("utils/search");
var avatars_1 = require("components/Avatar/avatars");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'name',
    'company',
    'id',
    'description',
    'status',
    'type'
];
exports.defaultQueryParams = {
    orderBy: 'id',
    order: 'asc',
    limit: '50',
    offset: '0'
};
function getNumber(params, field) {
    var val = params[field];
    if (val === undefined) {
        val = exports.defaultQueryParams[field];
    }
    if (val === undefined || val === null) {
        val = '0';
    }
    return parseInt(val, 10);
}
var mapStateToProps = function (state, ownProps) {
    return {
        list: state.subproject.list
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function () { return dispatch(subprojectActions.fetchRequest()); },
    clear: function () { return dispatch(subprojectActions.clear()); }
}); };
var subprojectMeta = function (meta) {
    if (meta.value !== null) {
        if (meta.identifier === 'subproject-status-meta') {
            return (0, translation_1.getLocalization)("subprojectStatus/".concat(meta.value));
        }
        else if (meta.identifier === 'subproject-responsible-person-meta' &&
            meta.type === 'reference') {
            return meta.value.value || '-';
        }
        else if (meta.type === 'day' && typeof meta.value === 'number') {
            return moment(meta.value).format('L');
        }
        else if (meta.type === 'reference') {
            return (meta.value.value ||
                meta.value.name ||
                '-');
        }
        return meta.value.toString();
    }
    return '-';
};
exports.subprojectMeta = subprojectMeta;
function getFilteredData(list, searchString, filters) {
    var lowerCaseSearchString = searchString.toLocaleLowerCase();
    var keys = Object.keys(filters);
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var p = item.project;
            var searchValue = filters[key];
            var value = void 0;
            switch (key) {
                case 'id':
                    value = p.id.toString();
                    break;
                case 'customer':
                    value = p.customerName;
                    break;
                case 'name':
                case 'description':
                    value = p[key];
                    break;
                case 'status':
                    value = p.projectStatus
                        ? (0, translation_1.getLocalization)("projectStatus/".concat(p.projectStatus.name))
                        : '-';
                    break;
                case 'type':
                    value = p.projectType
                        ? (0, translation_1.getLocalization)("projectType/".concat(p.projectType.name))
                        : '-';
                    break;
            }
            if (searchValue &&
                value &&
                value
                    .toString()
                    .toLowerCase()
                    .indexOf(searchValue.toLocaleLowerCase()) === -1) {
                return result;
            }
        }
        if (item.project.name
            .toString()
            .toLocaleLowerCase()
            .includes(lowerCaseSearchString) ||
            item.subproject.name
                .toString()
                .toLocaleLowerCase()
                .includes(lowerCaseSearchString)) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
}
var mapData = function (list, expanded) {
    var uniqProjects = list.reduce(function (acc, item) {
        if (acc.findIndex(function (x) { return x.id === item.project.id; }) === -1) {
            acc.push(item.project);
        }
        return acc;
    }, []);
    return uniqProjects.reduce(function (acc, project, index) {
        acc.push({
            type: 'PROJECT',
            color: index % 2 ? 'white' : 'gray',
            project: project,
            indent: 0
        });
        if (expanded.includes(project.id)) {
            return list.reduce(function (acc, item) {
                if (item.project.id === project.id) {
                    item.subproject.customMeta.sort(function (a, b) { return b.order - a.order; });
                    acc.push({
                        type: 'SUBPROJECT',
                        project: project,
                        subproject: item.subproject,
                        indent: 1
                    });
                }
                return acc;
            }, acc);
        }
        return acc;
    }, []);
};
var indent = (3.5 + 5) * 13;
var margin = 13 * 2;
var fontWeight = 1.7;
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('expanded', 'setExpanded', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetch();
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.list.status === 'STANDBY' &&
            this.props.list.status !== prevProps.list.status) {
            this.props.fetch();
        }
        var items = this.props.items;
        if (this.props.queryParams !== prevProps.queryParams ||
            this.props.expanded !== prevProps.expanded ||
            (prevProps.list.list.length === 0 && this.props.list.list.length) ||
            this.props.list.list !== prevProps.list.list ||
            (prevProps.list.status !== 'FETCHED' &&
                this.props.list.status === 'FETCHED')) {
            var _a = this.props.queryParams, order = _a.order, orderBy_1 = _a.orderBy, limit = _a.limit, offset = _a.offset, search = _a.search, filters = __rest(_a, ["order", "orderBy", "limit", "offset", "search"]);
            var orderMultiplier_1 = order === 'asc' ? 1 : -1;
            var list = this.props.list;
            var data = getFilteredData(list.list, search || '', filters || {}).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'name':
                        return (a.project[orderBy_1].localeCompare(b.project[orderBy_1]) *
                            orderMultiplier_1);
                    case 'type':
                        return ((a.project.projectType
                            ? a.project.projectType.name
                            : '').localeCompare(b.project.projectType ? b.project.projectType.name : '') * orderMultiplier_1);
                    case 'description':
                        return ((a.project.description || '').localeCompare(b.project.description || '') * orderMultiplier_1);
                    case 'company':
                        return ((a.project.customerName || '').localeCompare(b.project.customerName || '') * orderMultiplier_1);
                    case 'status':
                        return ((a.project.projectStatus
                            ? a.project.projectStatus.name
                            : '').localeCompare(b.project.projectStatus ? b.project.projectStatus.name : '') * orderMultiplier_1);
                    case 'id':
                        return (a.project[orderBy_1] - b.project[orderBy_1]) * orderMultiplier_1;
                    default:
                        return 0;
                }
            });
            var mappedData = mapData(data, this.props.expanded);
            items = mappedData.slice(Math.max(0, Math.min(mappedData.length, +(offset || '0'))), Math.min(+(offset || '0') + +(limit || '0'), mappedData.length));
            this.props.setTotal(mappedData.length);
            this.props.setItems(items);
        }
        if (items !== prevProps.items) {
            var columns_1 = items.reduce(function (p, item) {
                if (item.type === 'PROJECT') {
                    return headers.reduce(function (acc, c) {
                        var dataKey = '__' + c.replace(/-/g, '');
                        var text = (function (p, c) {
                            switch (c) {
                                case 'id':
                                    return p.id.toString();
                                case 'company':
                                    return p.customerName;
                                case 'name':
                                case 'description':
                                    return p[c];
                                case 'status':
                                    return p.projectStatus
                                        ? (0, translation_1.getLocalization)("projectStatus/".concat(p.projectStatus.name))
                                        : '-';
                                case 'type':
                                    return p.projectType
                                        ? (0, translation_1.getLocalization)("projectType/".concat(p.projectType.name))
                                        : '-';
                            }
                            return '';
                        })(item.project, c);
                        var length = (0, text_1.calculateStringLength)(text);
                        var prevValue = p.project[dataKey];
                        if (!prevValue || (prevValue && prevValue < length)) {
                            acc.project[dataKey] = length;
                        }
                        return acc;
                    }, p);
                }
                else if (item.type === 'SUBPROJECT') {
                    p.subprojectName =
                        (0, text_1.calculateStringLength)(item.subproject.name) +
                            13 +
                            indent * fontWeight;
                    p.metas[item.subproject.uuid] = 13 + indent;
                    return item.subproject.customMeta.reduce(function (acc, meta) {
                        var keyLength = (0, text_1.calculateStringLength)((0, translation_1.getLocalization)("subprojectMeta/".concat(meta.name)));
                        var valLength = (0, text_1.calculateStringLength)((0, exports.subprojectMeta)(meta));
                        acc.metas[item.subproject.uuid] +=
                            keyLength + valLength + margin;
                        return acc;
                    }, p);
                }
                return p;
            }, { project: {}, subprojectName: 0, metas: {} });
            headers.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("subprojectListView/column/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                if (!columns_1.project[dataKey] || columns_1.project[dataKey] < length) {
                    columns_1.project[dataKey] = length;
                }
            });
            var lengths_1 = Object.keys(columns_1.project).reduce(function (prev, x) {
                prev[x] = columns_1.project[x];
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('SubprojectListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'SubprojectListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            var projectRowContentWidth_1 = 2 * 42;
            var metaRowContentWidth = Object.values(columns_1.metas).reduce(function (acc, row) { return Math.max(acc, row); }, 0);
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                projectRowContentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(Math.max(projectRowContentWidth_1, columns_1.subprojectName, metaRowContentWidth));
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column __".concat(column), column === 'name' && 'expand'), "data-key": "__".concat(column) }, value));
}
function getHeaderColumn(props, name, identifier) {
    var order = props.queryParams.orderBy === identifier &&
        props.queryParams.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column subproject-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }, (0, translation_1.getLocalization)("subprojectListView/column/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.queryParams.orderBy === identifier
                ? (props.queryParams.order || 'name').toLowerCase()
                : null, disabled: !enabled, onChange: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames(props.queryParams[identifier] ? 'active' : '', ' filter'), columnIdentifier: identifier, textInputValue: props.queryParams[identifier]
                ? props.queryParams[identifier] || ''
                : '', inputType: identifier === 'id' ? 'number' : 'text', setColumnFilterString: function (field, value) {
                var params = __assign({}, props.queryParams);
                params[field] = value;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            }, clearColumnFilter: function (field) {
                var params = __assign({}, props.queryParams);
                params[field] = undefined;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } })));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-items', className: 'no-subprojects' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9') }),
    React.createElement("b", null, (0, translation_1.getLocalization)("global/dearSokoProUser")),
    React.createElement("span", null, (0, translation_1.getLocalization)("subprojectListView/emptyList/message")))); };
var Header = function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: 'row__column icons' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("global/collapseAll")) },
                React.createElement(sok_ui_1.Icon, { prefix: 'far', className: 'fa-chevron-square-up', onClick: function () {
                        props.setExpanded([]);
                    } })),
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("global/expandAll")) },
                React.createElement(sok_ui_1.Icon, { prefix: 'far', className: 'fa-chevron-square-down', onClick: function () {
                        props.setExpanded(props.items.map(function (x) { return x.project.id; }));
                    } }))),
        headers.map(function (header) { return getHeaderColumn(props, header, header); }),
        React.createElement("div", { className: 'row__column narrow' })));
};
var createRowData = function (style, items, expanded, setExpanded, selectedLanguage) { return ({
    style: style,
    items: items,
    expanded: expanded,
    setExpanded: setExpanded,
    selectedLanguage: selectedLanguage
}); };
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var row = data.items[index];
    if (row.type === 'PROJECT') {
        var expanded_1 = data.expanded.includes(row.project.id);
        return (React.createElement("div", { className: classNames('row', row.color), style: style },
            React.createElement("div", { className: 'row__column narrow project-expander', onClick: function () {
                    if (expanded_1) {
                        data.setExpanded(data.expanded.filter(function (x) { return x !== row.project.id; }));
                    }
                    else {
                        data.setExpanded(__spreadArray(__spreadArray([], data.expanded, true), [row.project.id], false));
                    }
                } },
                React.createElement(sok_ui_1.Icon, { className: "fa-chevron-".concat(expanded_1 ? 'up' : 'down') })),
            React.createElement("div", { className: 'row__column filler' }),
            React.createElement("div", { className: 'row__column __name' },
                React.createElement(react_router_dom_1.Link, { to: "/".concat(data.selectedLanguage, "/projects/").concat(row.project.id) },
                    React.createElement("div", null, row.project.name))),
            getColumn('company', row.project.customerName || '-'),
            getColumn('id', row.project.id.toString() || '-'),
            getColumn('description', row.project.description || '-'),
            getColumn('status', row.project.projectStatus
                ? (0, translation_1.getLocalization)("projectStatus/".concat(row.project.projectStatus.name))
                : '-'),
            getColumn('type', row.project.projectType
                ? (0, translation_1.getLocalization)("projectType/".concat(row.project.projectType.name))
                : '-'),
            React.createElement("div", { className: "row__column fill-".concat(1 - row.indent) })));
    }
    row.subproject.customMeta.sort(function (a, b) { return b.order - a.order; });
    return (React.createElement("div", { className: 'row', style: style },
        React.createElement("div", { className: 'row__column filler' }),
        React.createElement("div", { className: "row__column indent-".concat(row.indent) }),
        React.createElement("div", { className: "row__column ".concat(row.type.toLowerCase()) },
            React.createElement("div", { className: 'subproject-name' },
                React.createElement(react_router_dom_1.Link, { to: "/".concat(data.selectedLanguage, "/projects/").concat(row.project.id, "/files/").concat(row.subproject.id) }, row.subproject.name)),
            React.createElement("div", { className: 'inline-metas' }, row.subproject.customMeta.map(function (x) { return (React.createElement("div", null,
                (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name)),
                ":",
                ' ',
                (0, exports.subprojectMeta)(x))); }))),
        React.createElement("div", { className: 'row__column narrow' })));
});
exports.ListContainer = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    // memoize item props into props.data object
    var itemData = createRowData({}, props.items, props.expanded, props.setExpanded, selectedLanguage);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'subproject-list-view-list-container' },
            React.createElement("div", { className: 'sok-list-content subproject-list-view-list ' +
                    props.list.status.toLowerCase() },
                props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(); } }))),
                props.list.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.list.status === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, headerHeight: 45, itemHeight: 55, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder, null), striped: false }, ListRow));
                })))),
        React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: getNumber(props.queryParams, 'limit'), total: props.total, limitOptions: list_1.ITEMS_PER_PAGE, offset: getNumber(props.queryParams, 'offset'), updatePageState: function (offset, limit) {
                props.updateUrl(props.pathname +
                    (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { offset: offset, limit: limit })));
            } })));
});
